export default __webpack_public_path__ + "media/images/users/user-danny-nelson-70x70-1107babdbd4461ba7cdca376f0e3fd2f.jpg";